import { FC } from 'react';
import { Skeleton, Stack } from '@mui/material';

export const DTicketSubscriptionCancelSkeleton: FC = () => {
	return (
		<Stack gap={3}>
			{/* Section title */}
			<Skeleton variant="text" width="50%" height={28} />

			{/* Radio buttons - 8 reasons */}
			<Stack gap={2}>
				{Array.from({ length: 8 }, (_, i) => (
					<Skeleton key={i} variant="rounded" width="100%" height={48} />
				))}
			</Stack>

			{/* Warning message */}
			<Skeleton variant="rounded" width="100%" height={72} />

			{/* Checkbox */}
			<Stack direction="row" alignItems="center" gap={1}>
				<Skeleton variant="rounded" width={24} height={24} />
				<Skeleton variant="text" width="80%" height={20} />
			</Stack>

			{/* Submit button */}
			<Skeleton variant="rounded" width="100%" height={48} />
		</Stack>
	);
};
